import { InformationMessageType } from "../WorkflowManager";

export type ToastCallback = (callbackOptions: {
    toastMessage: null | string;
    toastType: InformationMessageType | null;
}) => void;

class Toast {
    private latestToast: null | string;
    private toastType: InformationMessageType | null;

    private toastCallbacks: ToastCallback[];

    constructor() {
        this.latestToast = null;
        this.toastType = null;
        this.toastCallbacks = [];
    }

    addToastCallback(callback: ToastCallback) {
        callback({
            toastMessage: this.latestToast,
            toastType: this.toastType,
        });
        this.toastCallbacks.push(callback);
    }

    removeToastCallback(callback: ToastCallback) {
        this.toastCallbacks = this.toastCallbacks.filter((it) => it !== callback);
    }

    setLatestToast(errorMessage: null | string, errorType: InformationMessageType | null) {
        this.latestToast = errorMessage;
        this.toastType = errorType;
        this.onToastChange();
    }

    private onToastChange() {
        this.toastCallbacks.forEach((callback) =>
            callback({
                toastMessage: this.latestToast,
                toastType: this.toastType,
            }),
        );
    }
}

const toast = new Toast();
export { toast };
